import { twMerge } from 'tailwind-merge';

import { ClassNameComponent } from '@/utils/ClassNameComponent';

export type Props = {
  children: React.ReactNode;
  className?: ClassNameComponent;
};

export default function CoursePathCardHeader(props: Props) {
  const { children, className } = props;
  return (
    <header
      className={twMerge(
        'flex justify-between items-center w-full gap-0.5',
        className?.base,
      )}
    >
      {children}
    </header>
  );
}
